import { DATE_IMAGE_SELECTED } from '../../action-types/ui/dateImageSelected';

export const STATE_KEY = 'dateImageSelected';

export const dateImageSelected = (state = false, action) => {
  switch (action.type) {
    case DATE_IMAGE_SELECTED: {
      return action.flag;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/dateImageSelected.js